var map = {
	"./add-something.svg": 4587,
	"./gallery-block.svg": 9204,
	"./image-file.svg": 213,
	"./image-video-block.svg": 8472,
	"./interactive-block.svg": 9009,
	"./text-block.svg": 9158,
	"./text-center.svg": 8764,
	"./text-left.svg": 8520,
	"./text-right.svg": 471,
	"./video-file.svg": 8851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;